var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXWaitingScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 587 254",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1133.2,-785.995)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1549.39,1444.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,527.843,165.075)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.558531,0,0,0.558531,969.124,-400.224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3172.7,-727.924C3172.7,-735.881 3169.54,-743.511 3163.92,-749.137C3158.29,-754.763 3150.66,-757.924 3142.7,-757.924L2603.97,-757.924C2596.02,-757.924 2588.39,-754.763 2582.76,-749.137C2577.13,-743.511 2573.97,-735.881 2573.97,-727.924L2573.97,-483.163C2573.97,-475.206 2577.13,-467.576 2582.76,-461.95C2588.39,-456.324 2596.02,-453.163 2603.97,-453.163L3142.7,-453.163C3150.66,-453.163 3158.29,-456.324 3163.92,-461.95C3169.54,-467.576 3172.7,-475.206 3172.7,-483.163L3172.7,-727.924ZM3147.28,-702.496C3147.28,-719.065 3133.84,-732.496 3117.28,-732.496C3028.42,-732.496 2718.25,-732.496 2629.4,-732.496C2612.83,-732.496 2599.4,-719.065 2599.4,-702.496L2599.4,-508.591C2599.4,-492.022 2612.83,-478.591 2629.4,-478.591C2718.25,-478.591 3028.42,-478.591 3117.28,-478.591C3133.84,-478.591 3147.28,-492.022 3147.28,-508.591L3147.28,-702.496Z",
    style: {
      fill: "rgb(42,94,96)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,195.524,-84.1546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2336.87,-546.076L2318.84,-499.043L2412.4,-499.043",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29294,0,0,0.78707,-531.231,-226.099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2456.06,-483.585L2347.25,-483.585L2374.45,-535.607L2428.86,-535.607L2456.06,-483.585Z",
    style: {
      fill: "rgb(42,94,96)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.352848,0,0,0.352848,2468.33,-33.7073)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1251.8,0,0,1238.63,572.152,-1064.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.076,-0.141C0.091,-0.158 0.105,-0.176 0.12,-0.194C0.135,-0.211 0.15,-0.229 0.165,-0.246L0.028,-0.411C0.033,-0.434 0.042,-0.453 0.057,-0.467C0.071,-0.481 0.088,-0.488 0.109,-0.488C0.119,-0.488 0.128,-0.487 0.135,-0.485C0.142,-0.482 0.149,-0.479 0.156,-0.474C0.162,-0.469 0.168,-0.464 0.174,-0.457C0.179,-0.45 0.185,-0.442 0.192,-0.433L0.264,-0.336L0.378,-0.487C0.381,-0.488 0.383,-0.488 0.386,-0.488L0.393,-0.488C0.421,-0.488 0.443,-0.482 0.46,-0.47C0.477,-0.458 0.485,-0.442 0.485,-0.423C0.485,-0.408 0.481,-0.394 0.474,-0.382C0.467,-0.37 0.453,-0.353 0.434,-0.332L0.356,-0.243L0.492,-0.064C0.489,-0.041 0.48,-0.023 0.465,-0.01C0.45,0.004 0.432,0.01 0.411,0.01C0.389,0.009 0.371,0.003 0.358,-0.01C0.344,-0.022 0.33,-0.037 0.317,-0.056L0.253,-0.148L0.143,0.007L0.123,0.008C0.093,0.008 0.07,0.002 0.054,-0.011C0.038,-0.024 0.03,-0.039 0.03,-0.058C0.03,-0.072 0.033,-0.085 0.04,-0.096C0.047,-0.107 0.059,-0.122 0.076,-0.141Z",
    style: {
      fill: "rgb(249,98,99)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10536,0,0,1.10536,-19.5436,-2889.41)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.709386,0,0,0.709386,7.08472,738.28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999,
    style: {
      fill: "white"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1330.98,749.637C1268.01,749.637 1216.89,800.756 1216.89,863.719C1216.89,926.683 1268.01,977.802 1330.98,977.802C1393.94,977.802 1445.06,926.683 1445.06,863.719C1445.06,800.756 1393.94,749.637 1330.98,749.637ZM1330.98,770.721C1382.3,770.721 1423.98,812.392 1423.98,863.719C1423.98,915.047 1382.3,956.718 1330.98,956.718C1279.65,956.718 1237.98,915.047 1237.98,863.719C1237.98,812.392 1279.65,770.721 1330.98,770.721Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.322543,0,0,0.322543,541.889,1056.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10536,0,0,1.10536,-262.507,-2889.41)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.709386,0,0,0.709386,7.08472,738.28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999,
    style: {
      fill: "white"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.98,749.637C1268.01,749.637 1216.89,800.756 1216.89,863.719C1216.89,926.683 1268.01,977.802 1330.98,977.802C1393.94,977.802 1445.06,926.683 1445.06,863.719C1445.06,800.756 1393.94,749.637 1330.98,749.637ZM1330.98,770.721C1382.3,770.721 1423.98,812.392 1423.98,863.719C1423.98,915.047 1382.3,956.718 1330.98,956.718C1279.65,956.718 1237.98,915.047 1237.98,863.719C1237.98,812.392 1279.65,770.721 1330.98,770.721Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.322543,0,0,0.322543,541.889,1056.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,454.623,-218.187)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0760976,1.04851,-0.455928,-0.0330897,2438.64,-2886.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2556.29,-266.999C2556.29,-285.121 2549.9,-299.812 2542.02,-299.812C2523.18,-299.812 2490.2,-299.812 2471.37,-299.812C2463.49,-299.812 2457.1,-285.121 2457.1,-266.999C2457.1,-241.942 2457.1,-207.57 2457.1,-182.513C2457.1,-164.39 2463.49,-149.699 2471.37,-149.699C2490.2,-149.699 2523.18,-149.699 2542.02,-149.699C2549.9,-149.699 2556.29,-164.39 2556.29,-182.513L2556.29,-266.999Z",
    style: {
      fill: "rgb(42,94,96)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.16407,0,0,1.26312,-531.92,55.8827)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2446.53,
    cy: -228.383,
    rx: 22.324,
    ry: 21.482,
    style: {
      fill: "rgb(249,98,99)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.16407,0,0,1.26312,-465.705,60.8212)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2446.53,
    cy: -228.383,
    rx: 22.324,
    ry: 21.482,
    style: {
      fill: "rgb(249,98,99)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWaitingScreen);
export default __webpack_public_path__ + "static/media/x_waiting_screen.224b1099af0db4e33b3f4ed219259906.svg";
export { ForwardRef as ReactComponent };